import React, { Children } from 'react';
import { motion } from 'framer-motion';
const fadeUpVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
const staggerContainer = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
export function DiagnosisSection() {
  const problems = [{
    id: '01',
    title: 'Las redes sociales generan likes, no citas.',
    body: 'Puedes tener 10,000 seguidores en Instagram y la agenda vacía porque los seguidores no son clientes. Los clientes son los que sacan su tarjeta de crédito.'
  }, {
    id: '02',
    title: 'Los descuentos atraen al cliente equivocado.',
    body: 'El cliente que viene por el 50% de descuento no valora tu trabajo. Negocia el precio en cada visita. No te refiere a sus amigos. Y cuando vuelva la tarifa normal, no regresa.'
  }, {
    id: '03',
    title: 'No tienes un sistema de retención.',
    body: 'Conseguir un cliente nuevo cuesta 5 veces más que retener uno que ya tienes. Si no tienes un sistema automatizado de recordatorios y reactivación, estás perdiendo dinero cada día.'
  }];
  return <section className="py-16 md:py-24 px-4 bg-carbon" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={fadeUpVariants} className="text-center mb-16" data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-bold text-gold" data-id="element-4">
            La razón real por la que tu agenda tiene huecos.
          </h2>
        </motion.div>

        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={staggerContainer} className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8" data-id="element-5">
          {problems.map(problem => <motion.div key={problem.id} variants={fadeUpVariants} className="bg-surface p-8 rounded-xl border border-white/5 hover:border-white/10 transition-colors" data-id="element-6">
              <div className="text-gold/20 font-black text-5xl mb-4 tracking-tighter" data-id="element-7">
                {problem.id}
              </div>
              <h3 className="text-xl font-bold text-white mb-4 leading-snug" data-id="element-8">
                {problem.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-9">{problem.body}</p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}